import { DefaultOptionType } from "antd/es/select";
import { SelectEntity } from "../types";
import { Uuid } from "types";

export const getOnSelectData = (v: DefaultOptionType) : SelectEntity => {
  return {
    label: v.label as any,
    value: v.value as Uuid,
  }
} 